import React, { useEffect } from 'react';
import { usetifulService } from '../../../lib/services/usetiful.service';

interface UsetifulProviderProps {
  children: React.ReactNode;
}

/**
 * UsetifulProvider Component
 * 
 * Initializes and configures Usetiful for the MaxAnalytics application.
 * This component should be placed high in the component tree to ensure
 * Usetiful is available throughout the application.
 */
const UsetifulProvider: React.FC<UsetifulProviderProps> = ({ children }) => {
  
  useEffect(() => {
    // Get Usetiful token from environment variables
    const usetifulToken = process.env.REACT_APP_USETIFUL_TOKEN;
    
    if (!usetifulToken) {
      console.warn('🚫 REACT_APP_USETIFUL_TOKEN not found in environment variables');
      console.log('ℹ️  To enable Usetiful, add REACT_APP_USETIFUL_TOKEN to your .env file');
      return;
    }

    // Initialize Usetiful
    usetifulService.initialize(usetifulToken);
    
  }, []);

  useEffect(() => {
    // Set environment-specific tags when service is ready
    if (!usetifulService.isReady()) return;

    try {
      // Set basic environment tags
      usetifulService.setTags({
        environment: process.env.NODE_ENV || 'development',
        appVersion: process.env.REACT_APP_VERSION || '0.0.1',
        timestamp: new Date().toISOString(),
      });

    } catch (error) {
      console.error('❌ Failed to set Usetiful environment tags:', error);
    }
  }, []);

  return <>{children}</>;
};

export default UsetifulProvider;